import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_DeleteFacesCommand, se_DeleteFacesCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class DeleteFacesCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "DeleteFaces", {})
    .n("RekognitionClient", "DeleteFacesCommand")
    .f(void 0, void 0)
    .ser(se_DeleteFacesCommand)
    .de(de_DeleteFacesCommand)
    .build() {
}
